const initialState = {
  config: {
    digitalCardWarningMessage: ""
  },
  items: [],
  pills: [],
  filters: {
    search: "",
    date: null,
    type: "",
    toggle: false
  },
  pagination: {
    currentPage: 1,
    totalPages: 1
  }
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_WALLET_CONFIG":
      return {
        ...state,
        config: payload
      }

    case "SAVE_WALLET_ITEMS":
      return {
        ...state,
        items: payload
      }

    case "SAVE_WALLET_PILLS":
      return {
        ...state,
        pills: payload
      }

    case "SAVE_WALLET_FILTERS":
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload
        }
      }

    case "SAVE_WALLET_PAGINATION":
      return {
        ...state,
        pagination: payload
      }

    default:
      return state
  }
}
